module.exports = __webpack_public_path__ + "img/clock.8c5ad98a.svg";